import React from 'react';
import { Link } from 'react-router-dom';
import { LOGO_URL } from '../lib/images';

const APP_NAME = 'Today: Daily Reset';
const SUPPORT_EMAIL = 'support@todaytheapp.com';

const footerLinks = [
  { to: '/about', label: 'About' },
  { to: '/privacy-policy', label: 'Privacy' },
  { to: '/terms', label: 'Terms' },
  { to: '/contact', label: 'Contact' },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="mt-16 border-t"
      style={{ borderColor: 'var(--border)', background: 'var(--surface)' }}
      data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-6 sm:px-8 py-10 grid grid-cols-1 md:grid-cols-[1.4fr_1fr_1fr] gap-8">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <img src={LOGO_URL} alt="Today" className="w-8 h-8 rounded-full" />
            <span className="font-bold" style={{ fontFamily: 'Manrope', color: 'var(--text)' }}>
              {APP_NAME}
            </span>
          </div>
          <p className="text-sm max-w-sm leading-relaxed" style={{ color: 'var(--muted-fg)' }}>
            Your daily companion for mindful mood tracking, gratitude journaling, wellness programs, and personal reflection.
          </p>
        </div>

        <div>
          <p className="text-xs uppercase tracking-widest font-semibold mb-3"
            style={{ color: 'var(--muted-fg)', fontFamily: 'Manrope' }}>
            Today Platform
          </p>
          <ul className="space-y-2">
            {footerLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  className="text-sm transition-colors hover:opacity-100"
                  style={{ color: 'var(--text)', opacity: 0.75 }}>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-widest font-semibold mb-3"
            style={{ color: 'var(--muted-fg)', fontFamily: 'Manrope' }}>
            Support
          </p>
          <a href={`mailto:${SUPPORT_EMAIL}`}
            data-testid="footer-support-email"
            className="text-sm transition-colors hover:opacity-100 block"
            style={{ color: 'var(--text)', opacity: 0.75 }}>
            {SUPPORT_EMAIL}
          </a>
          <p className="text-xs mt-3" style={{ color: 'var(--muted-fg)' }}>
            We reply within 24 hours on weekdays.
          </p>
        </div>
      </div>
      <div className="border-t px-6 sm:px-8 py-5" style={{ borderColor: 'var(--border)' }}>
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 text-xs"
          style={{ color: 'var(--muted-fg)' }}>
          <p>© {year} {APP_NAME}. Made with care.</p>
          <p>
            <Link to="/privacy-policy" className="hover:opacity-100 opacity-75 mr-4"
              style={{ color: 'var(--text)' }}>Privacy</Link>
            <Link to="/terms" className="hover:opacity-100 opacity-75"
              style={{ color: 'var(--text)' }}>Terms</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
